import { createOptionTabs, OptionTabs, OPTION_TABS_STATE_CHECKED } from '@vfde-brix/option-tabs';
import { areIdsEqual } from '../helper/validator';
import { Id } from '../interface/AdditionalPageOptions';
import { Tariff } from '../interface/dto/Tariffs';
import { selectOption } from '../container/App/action';
import getPageOptions from '../helper/additionalPageOptionsHelper';

// Icon included in sails-core doesnt work
const ICON_UNLIMITED = 'i-unlimited-sml';

export const updateOptionTab = (comp: OptionTabs | null, subs: Tariff[], selectedSubId?: Id) => {
    if (!comp) {
        return;
    }

    const items = comp.getProperties().items;
    const unlimitedId = getPageOptions()?.unlimitedId;

    items.forEach(item => {
        item.state = areIdsEqual(selectedSubId, item.stdValue)
            ? OPTION_TABS_STATE_CHECKED
            : undefined;

        const subscription = subs.find(sub => areIdsEqual(sub.virtualItemId, item.stdValue));
        const unlimited = subscription?.dataVolume.withoutDiscounts?.[0]?.unlimited
            || areIdsEqual(item.stdValue, unlimitedId);

        item.icon = unlimited ? ICON_UNLIMITED : undefined;
    });

    comp.update({ items });
};

const mountOptionTabs = (wrapperId: string, onChange: typeof selectOption) => {
    const containerEl = document.getElementById(wrapperId);

    return containerEl && createOptionTabs(containerEl, {
        onChange: (value, _) => onChange(value, undefined),
    });
};

export default mountOptionTabs;
